<div class="modal-header">
  <h2 class="modal-title">
    {{ 'paymentModule.payment' | translate }}
  </h2>
</div>

<div class="modal-body">
  <form (ngSubmit)="onFormSubmit()" [formGroup]="form">
    <div class="mb-4">
      <label class="form-label">
        {{ 'saleModule.collectStatus' | translate }}
      </label>

      <select
        formControlName="collectStatus"
        class="form-select"
        [attr.aria-invalid]="
          form.controls.collectStatus.dirty &&
          form.controls.collectStatus.invalid
            ? 'true'
            : null
        "
      >
        <option
          *ngFor="let collectStatusValue of CollectStatusType"
          [value]="collectStatusValue.value"
        >
          {{
            'paymentModule.collectStatus' + collectStatusValue.value | translate
          }}
        </option>
      </select>
      <p
        *ngIf="
          form.controls.collectStatus.dirty &&
          form.controls.collectStatus.invalid
        "
        class="invalid-feedback"
        role="alert"
        aria-atomic="true"
      >
        <i role="img" class="fas fa-exclamation-circle" aria-hidden="true"></i>
      </p>
    </div>

    <!-- End Row -->

    <div class="form-footer">
      <button class="btn btn-primary" type="submit">
        {{ 'general.save' | translate }}
      </button>
    </div>
  </form>
</div>
